export const SERVER_ERROR_MESSAGE =
	"エラーが発生しました\r\n時間をおいてもう一度お試しください。";

export const VENDOR_API_PREFIX = "/vendors";

export const AI_OWNER_EXPLANATION_SUGGESTION_HELP_URL =
	"https://itandibb.support.itandi.co.jp/hc/ja/articles/54035463950739-AI%E3%82%AA%E3%83%BC%E3%83%8A%E3%83%BC%E8%AA%AC%E6%98%8E%E3%82%B5%E3%82%B8%E3%82%A7%E3%82%B9%E3%83%88-%CE%B2%E7%89%88-%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6";

export const TAX_RATE = 0.1;
